import classnames from "classnames";

export interface ContainerProps {
  children?: React.ReactNode;
  className?: string;
  maxWidth?: "md" | "lg" | "full";
}

export const Container = ({
  maxWidth = "lg",
  className,
  children,
}: ContainerProps) => {
  const maxWidths = {
    md: "lg:max-w-2xl",
    lg: "lg:max-w-5xl",
    full: "max-w-full",
  };

  const maxWidthClass = maxWidths[maxWidth] || maxWidths.lg;

  return (
    <div
      className={classnames(
        "lg:mx-auto lg:flex lg:gap-6",
        maxWidthClass,
        className,
      )}
    >
      {children}
    </div>
  );
};
